"use strict";
/**
 * Created by cuppi on 2016/12/7.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/** @module tool*/
/**
 * 数组工具类
 * @hideconstructor
 */
class ArrayTool {
}
exports.default = ArrayTool;
